/* Turnpaugh navigation: native controls alongside the legacy theme's styling. */
(function () {
  'use strict';
  var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var drawerOpen = false;
  var drawerOpener = null;
  var searchOpener = null;
  var inertBackground = [];

  function visibleControls(container) {
    return Array.prototype.filter.call(container.querySelectorAll(focusableSelector), function (element) {
      return element.getClientRects().length && !element.closest('[inert], [hidden]');
    });
  }

  function restoreFocus(element) {
    if (element && element.isConnected && element.getClientRects().length) element.focus();
  }

  function trapTab(event, container) {
    if (event.key !== 'Tab') return;
    var controls = visibleControls(container);
    var first = controls[0];
    var last = controls[controls.length - 1];
    if (!first) {
      event.preventDefault();
      container.focus();
    } else if (event.shiftKey && (document.activeElement === first || document.activeElement === container || !container.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !container.contains(document.activeElement))) {
      event.preventDefault();
      first.focus();
    }
  }

  function setDrawer(open, opener, returnFocus) {
    var drawer = document.getElementById('NavDrawer');
    if (!drawer || open === drawerOpen) return;
    drawerOpen = open;
    if (open) {
      drawerOpener = opener || document.activeElement;
      setSearch(false, null, false);
    }
    drawer.inert = !open;
    drawer.setAttribute('aria-hidden', String(!open));
    document.documentElement.classList.toggle('js-drawer-open', open);
    document.documentElement.classList.toggle('js-drawer-open-left', open);
    document.body.classList.toggle('js-drawer-open', open);
    document.body.classList.toggle('js-drawer-open-left', open);
    document.querySelectorAll('button.js-drawer-open-left').forEach(function (button) {
      button.setAttribute('aria-expanded', String(open));
      button.classList.toggle('js-drawer-open', open);
    });
    if (open) {
      // The dialog is a body child. Keep scripts and the dialog itself available.
      inertBackground = Array.prototype.filter.call(document.body.children, function (element) {
        return element !== drawer && !/^(SCRIPT|STYLE|LINK)$/.test(element.tagName) && !element.inert;
      });
      inertBackground.forEach(function (element) { element.inert = true; });
      drawer.focus();
    } else {
      inertBackground.forEach(function (element) { element.inert = false; });
      inertBackground = [];
      if (returnFocus !== false) restoreFocus(drawerOpener);
    }
  }

  function setSearch(open, opener, returnFocus) {
    var form = document.getElementById('form-search-header');
    if (!form) return;
    var wrap = form.closest('.site-header__search-wrap');
    var overlay = wrap && wrap.querySelector('.overlay');
    var wasOpen = form.classList.contains('active');
    if (open) {
      searchOpener = opener || document.activeElement;
      if (drawerOpen) setDrawer(false, null, false);
    }
    form.classList.toggle('active', open);
    form.setAttribute('aria-hidden', String(!open));
    form.inert = !open;
    if (overlay) overlay.classList.toggle('active', open);
    document.querySelectorAll('[data-header-search-open]').forEach(function (button) {
      button.setAttribute('aria-expanded', String(open));
    });
    if (open) {
      var input = form.querySelector('input[type="search"]');
      if (input) input.focus();
    } else if (wasOpen && returnFocus !== false) restoreFocus(searchOpener);
  }

  function setMenu(button, open) {
    var panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    button.setAttribute('aria-expanded', String(open));
    button.parentElement.classList.toggle('tp-nav-open', open);
    if (!open) {
      panel.querySelectorAll('[data-nav-toggle]').forEach(function (child) { setMenu(child, false); });
    }
  }

  function initializeMenus() {
    document.querySelectorAll('[data-nav-toggle]').forEach(function (button) {
      if (button.dataset.navReady) return;
      button.dataset.navReady = 'true';
      var item = button.parentElement;
      var link = button.previousElementSibling;
      item.addEventListener('pointerenter', function (event) {
        if (event.pointerType !== 'touch') setMenu(button, true);
      });
      item.addEventListener('pointerleave', function (event) {
        if (event.pointerType !== 'touch' && !item.contains(document.activeElement)) setMenu(button, false);
      });
      if (link) link.addEventListener('focus', function () { setMenu(button, true); });
      item.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!item.contains(document.activeElement)) setMenu(button, false);
        }, 0);
      });
    });
    document.querySelectorAll('.nav-bar').forEach(function (nav) { nav.classList.add('tp-nav-ready'); });
  }

  // Capture only our navigation controls, so legacy Drawers/Bootstrap cannot double-toggle them.
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var opener = event.target.closest('button.js-drawer-open-left');
    var drawer = document.getElementById('NavDrawer');
    var close = event.target.closest('#NavDrawer .js-drawer-close');
    if (opener || close || (drawerOpen && drawer && !drawer.contains(event.target))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setDrawer(opener ? !drawerOpen : false, opener);
      return;
    }
    var collapse = event.target.closest('#NavDrawer [data-toggle="collapse"]');
    if (collapse) {
      var panel = document.getElementById(collapse.getAttribute('aria-controls'));
      if (panel) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var expanded = collapse.getAttribute('aria-expanded') !== 'true';
        collapse.setAttribute('aria-expanded', String(expanded));
        collapse.classList.toggle('collapsed', !expanded);
        panel.classList.toggle('show', expanded);
      }
      return;
    }
    var menuButton = event.target.closest('[data-nav-toggle]');
    if (menuButton) {
      event.preventDefault();
      setMenu(menuButton, menuButton.getAttribute('aria-expanded') !== 'true');
      return;
    }
    var searchOpen = event.target.closest('[data-header-search-open]');
    var searchClose = event.target.closest('[data-header-search-close]');
    if (searchOpen || searchClose) {
      event.preventDefault();
      setSearch(Boolean(searchOpen), searchOpen);
    }
    if (!event.target.closest('.nav-bar')) {
      document.querySelectorAll('[data-nav-toggle][aria-expanded="true"]').forEach(function (button) { setMenu(button, false); });
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    var drawer = document.getElementById('NavDrawer');
    if (drawerOpen && drawer) {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopImmediatePropagation();
        setDrawer(false);
      } else trapTab(event, drawer);
      return;
    }
    var search = document.getElementById('form-search-header');
    if (search && search.classList.contains('active')) {
      if (event.key === 'Escape') {
        event.preventDefault();
        setSearch(false);
      }
      return;
    }
    if (!(event.target instanceof Element)) return;
    var item = event.target.closest('.site-nav__dropdown-container, .site-nav__item');
    if (!item) return;
    var button = Array.prototype.find.call(item.children, function (child) { return child.matches('[data-nav-toggle]'); });
    if (event.key === 'Escape') {
      var openItem = event.target.closest('.tp-nav-open');
      if (!openItem) return;
      button = Array.prototype.find.call(openItem.children, function (child) { return child.matches('[data-nav-toggle]'); });
      if (button) {
        event.preventDefault();
        event.stopPropagation();
        setMenu(button, false);
        button.focus();
      }
    } else if (button && event.key === 'ArrowDown' && (event.target === button || event.target === button.previousElementSibling)) {
      event.preventDefault();
      setMenu(button, true);
      var panel = document.getElementById(button.getAttribute('aria-controls'));
      var first = panel && visibleControls(panel)[0];
      if (first) first.focus();
    }
  }, true);

  document.addEventListener('focusin', function (event) {
    if (drawerOpen) {
      var drawer = document.getElementById('NavDrawer');
      if (drawer && !drawer.contains(event.target)) drawer.focus();
    }
    var search = document.getElementById('form-search-header');
    if (search && search.classList.contains('active') && !search.closest('.site-header__search-wrap').contains(event.target)) {
      setSearch(false, null, false);
    }
  });

  var desktop = window.matchMedia('(min-width: 992px)');
  function onBreakpointChange() {
    if (desktop.matches && drawerOpen) setDrawer(false);
    if (!desktop.matches) setSearch(false, null, false);
  }
  if (desktop.addEventListener) desktop.addEventListener('change', onBreakpointChange);
  else desktop.addListener(onBreakpointChange);
  document.addEventListener('shopify:section:load', initializeMenus);
  document.addEventListener('shopify:section:unload', function () {
    if (drawerOpen) setDrawer(false, null, false);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeMenus);
  else initializeMenus();
})();
